import Phaser from 'phaser'

import { sceneEvents } from '../events/EventsCenter'

export default class GameUI extends Phaser.Scene
{
	private hearts!: Phaser.GameObjects.Group

	constructor()
	{
		super({ key: 'game-ui' })
	}

	create()
	{

		this.add.image(12, 31, 'treasure', 'coin_anim_f0.png')
		const coinsLabel = this.add.text(36, 26, '--', { fontFamily: '"Monospace"', fontSize: '14'});

		this.add.text(12, 40, 'PPL', { fontFamily: '"Monospace"', fontSize: '14'});
		const pplLabel = this.add.text(36, 40, '--', { fontFamily: '"Monospace"', fontSize: '14'});

		// const coinsLabel = this.add.text(36, 50, '--', { fontFamily: '"Monospace"', fontSize: '14'});
		// const coinsLabel = this.add.text(12, 20, '0', {
		// 	fontSize: '14'
		// })

		// sceneEvents.on('player-coins-changed', (coins: number) => {
		// 	coinsLabel.text = coins.toLocaleString()
		// })

		// this.hearts = this.add.group({
		// 	classType: Phaser.GameObjects.Image
		// })

		// this.hearts.createMultiple({
		// 	key: 'ui-heart-full',
		// 	setXY: {
		// 		x: 10,
		// 		y: 10,
		// 		stepX: 16
		// 	},
		// 	quantity: 3
		// })

		// sceneEvents.on('player-health-changed', this.handlePlayerHealthChanged, this)

		// this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
		// 	sceneEvents.off('player-health-changed', this.handlePlayerHealthChanged, this)
		// 	sceneEvents.off('player-coins-changed')
		// })

		sceneEvents.on('new-npc', (v: number) => {
			pplLabel.setText('' + v)
		})

		sceneEvents.on('update-tx-count', (v: number) => {
			coinsLabel.setText('' + v)			
		})
	}

}
